var React = require('react');

function Empty (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#C8C8C8","fillRule":"evenodd","d":"M8.15 12.544L3.629 15.96c-.201.107-.503 0-.402-.32l1.507-5.445L.11 6.78c-.201-.214-.1-.534.1-.534l5.528-.534 2.01-5.55a.277.277 0 0 1 .503 0l2.01 5.55 5.529.534c.2 0 .301.32.1.427l-4.523 3.523 1.508 5.445c.1.213-.201.427-.402.32L8.15 12.544z"}));
}

Empty.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Empty;

Empty.default = Empty;
